import React, { useCallback, useEffect, useState } from "react";
import CardTable from "../../../components/AdminTable/CardTable";
import { FaCog, FaEdit, FaEye, FaTrashAlt } from "react-icons/fa";
// import Dropdown from "../../../components/AdminDropdown/Dropdown";
import axios from "axios";
import { apiKey } from "../../../config/config";
import { toast } from "react-toastify";
import { IoIosArrowDown } from "react-icons/io";
import { Link } from "react-router-dom";

function Expenses() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const [pageLoading, setPageLoading] = useState(true);
  const [error, setError] = useState(false);
  const columns = [
    {
      header: "SN",
      cell: (row) => row.row.index + 1,
    },
    {
      header: "Date",
      accessorKey: "date",
    },
    {
      header: "Amount",
      accessorKey: "amount",
    },
    {
      header: "Vat Percentage	",
      accessorKey: "vat_percentage",
    },
    {
      header: "Vat",
      accessorKey: "vat",
    },

    {
      header: "Tax Method",
      accessorKey: "tax_method",
    },
    {
      header: "Category",
      // accessorKey: "Category",
      cell: (row) => row.row.original.category?.name,
    },
    {
      header: "Payment Method",
      // accessorKey: "Paymentmethod",
      cell: (row) => row.row.original.payment_method?.name,
    },
    {
      header: "Responsible Person	",
      // accessorKey: "ResponsiblePerson",
      cell: (row) => row.row.original.employee?.name,
    },
    {
      header: "Note",
      accessorKey: "note",
    },

    {
      header: "Actions",
      accessorKey: "total",
      cell: (row) => (
        <ActionDropdown
          id={row.row.original.id}
          user={user}
          refetchData={fetchData}
        />
      ),
    },
  ];
  const [data, setData] = useState([]);
  const buttonData = [
    {
      buttonText: "Add Expenses ",
      path: "addExpenseForm",
    },
  ];

  const fetchData = useCallback(() => {
    axios
      .get(`${apiKey}/api/rms/admin/expense`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
        params: {
          outletId: user?.user.outlet_id
        }
      })
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => {
        setError(err.response.data.message);
      })
      .finally(() => {
        setPageLoading(false);
      });
  }, [user?.token, user?.user.outlet_id]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);
  return (
    <main>
      <CardTable
        data={data}
        columns={columns}
        error={error}
        heading={"Expenses "}
        buttonData={buttonData}
      />
      {pageLoading && (
        <div className="absolute top-0 left-0 w-full h-full grid place-items-center">
          <img src="/assets/gif/dash2.gif" alt="" />
        </div>
      )}
    </main>
  );
}

function ActionDropdown({ id, user, refetchData }) {
  const [showDropdown, setShowDropDown] = useState(false);
  const [showDelModal, setShowDelModal] = useState(false);

  const handleDelete = () => {
    axios
      .delete(`${apiKey}/api/rms/admin/expense/${id}`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {
        toast.success(res.data.message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        refetchData();
        setShowDelModal(false);
        setShowDropDown(false);
      })
      .catch((err) => {
        toast.error(err.response.data.message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  };

  return (
    <>
      <div className="relative">
        <button
          className="text-blueGray-500 px-3 flex items-center justify-between gap-1 border rounded-full"
          onClick={() => setShowDropDown(!showDropdown)}
        >
          <FaCog className="text-d-bg-text" />
          <IoIosArrowDown className="text-d-bg-text" />
        </button>
        <div
          className={
            (showDropdown ? "block " : "hidden ") +
            "absolute top-4 left-0 -translate-x-[75%] bg-white text-base z-10 float-left py-2 list-none text-left rounded shadow-lg min-w-40"
          }
        >
          <Link
            to={`addExpenseForm/${id}`}
            className={
              "text-sm py-2 px-4 font-normal flex items-center gap-4 w-full whitespace-nowrap bg-transparent text-blueGray-700"
            }
          >
            <FaEdit />
            <p> Edit </p>
          </Link>
          <Link
            to={`expenseDetails/${id}`}
            className={
              "text-sm py-2 px-4 font-normal flex items-center gap-4 w-full whitespace-nowrap bg-transparent text-blueGray-700"
            }
          >
            <FaEye />
            <p> View Details </p>
          </Link>
          <button
            onClick={() => setShowDelModal(true)}
            className={
              "text-sm py-2 px-4 font-normal flex items-center gap-4 w-full whitespace-nowrap bg-transparent text-blueGray-700"
            }
          >
            <FaTrashAlt />
            <p> Delete </p>
          </button>
        </div>
      </div>

      {showDelModal && (
        <div
          className="w-full h-screen overflow-y-auto grid place-items-center fixed top-0 left-0 bg-black bg-opacity-50 backdrop-blur-md p-4 z-10"
          onClick={() => setShowDelModal(false)}
        >
          <div
            className="p-4 rounded-lg bg-white max-w-md w-full space-y-4"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="space-y-4">
              <h1 className="text-d-bg-text font-semibold text-xl text-center">
                Alert!
              </h1>
              <p className="text-center text-gray-700">Are you sure?</p>
            </div>
            <div className="flex justify-center gap-4">
              <button
                className="bg-d-cat-btn text-white font-bold text-sm px-4 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center"
                onClick={() => setShowDelModal(false)}
              >
                No
              </button>
              <button
                onClick={handleDelete}
                className="bg-d-cat-btn text-white font-bold text-sm px-4 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center"
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Expenses;
